import { LocaleMessages } from 'vue-i18n'

const infraEnUsLocaleMessages: LocaleMessages = {
  vm: {
    title: 'Virtual Machine',
    pluralTitle: 'Virtual Machines'
  },
  vmPayload: {
    field: {
      id: 'Id',
      node: 'Node',
      name: 'Name',
      status: 'Status',
      cpuUsage: 'CPU Usage',
      memoryUsage: 'Memory Usage',
      lastDeploy: 'Last Deploy',
      lastDeployDatetime: 'Last Deploy at',
      cronLastDatetime: 'Last Cron at',
      cronNextDatetime: 'Next Cron at',
      cron: 'Cron'
    },
    alert: {
      command: {
        START_DEPLOY: 'Are you sure you want to start the deploy on this virtual machine?',
        START: 'Are you sure you want to start this virtual machine?',
        SHUTDOWN: 'Are you sure you want to shutdown this virtual machine?',
        REBOOT: 'Are you sure you want to reboot this virtual machine?'
      }
    },
    notification: {
      command: {
        START_DEPLOY: 'The virtual machine will start the deploy soon.',
        START: 'The virtual machine will start soon.',
        SHUTDOWN: 'The virtual machine will shutdown soon.',
        REBOOT: 'The virtual machine will reboot soon.'
      }
    },
    value: {
      status: {
        STOPPED: 'Stopped',
        RUNNING: 'Running'
      },
      lastDeploy: {
        STARTED: 'Started',
        COMPLETED: 'Completed',
        CANCELED: 'Canceled',
        FAILED: 'Failed'
      },
      command: {
        START_DEPLOY: 'Start the Deploy',
        START: 'Start',
        SHUTDOWN: 'Shutdown',
        REBOOT: 'Reboot'
      }
    }
  }
}

export default infraEnUsLocaleMessages